import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@tinct/web-components';
import { ServiceAccount } from '@tinct/core-api-models';
import { useEnableServiceAccount } from '@tinct/core-api';
import { IconCircleCheck } from '@tabler/icons-react';
import { toast } from 'sonner';

type EnableServiceAccountModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  organizationId: string;
  serviceAccount: ServiceAccount;
};

export const EnableServiceAccountModal = ({
  open,
  onOpenChange,
  organizationId,
  serviceAccount,
}: EnableServiceAccountModalProps) => {
  const enableServiceAccount = useEnableServiceAccount({
    onSuccess: () => {
      toast.success('Service account enabled');
      onOpenChange(false);
    },
    onError: (error) => {
      toast.error(error.message || 'Failed to enable service account');
    },
  });

  const handleEnable = () => {
    if (!serviceAccount.id) return;
    enableServiceAccount.mutate({
      organizationId,
      serviceAccountId: serviceAccount.id,
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Enable service account</DialogTitle>
        </DialogHeader>

        <div className="flex gap-3 items-start rounded-lg border border-neutral-200 bg-muted px-4 py-3">
          <div className="pt-0.5">
            <IconCircleCheck className="size-4" />
          </div>
          <div className="flex flex-col gap-1 flex-1">
            <p className="text-sm font-medium">
              Service account: {serviceAccount.name}
            </p>
            <p className="text-sm text-muted-foreground">
              It will be able to obtain tokens and call the API again with its
              existing credentials.
            </p>
          </div>
        </div>

        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={handleEnable}
            isLoading={enableServiceAccount.isPending}
          >
            Enable
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
